import { app } from '../../../../app';
import { Controller } from './idp-authenticators-list.controller';

app.component('companyIdpAuthenticatorsList', {
    bindings: {
        companyId: '<',
        idpAuthenticators: '<',
    },
    controller: Controller,
    templateUrl: require('./idp-authenticators-list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/list/idp-authenticators-list.component.js